<div class="container">



    <h1 class="text-center mt-5" style="color: #f8ad33;font-weight: 1000 !important;">MENTIONS LÉGALES</h1>


    <h1 class="text-left" style="color: #a2b73d;"><b>1. Présentation du site :</b></h1>
    <p>Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la Confiance
        dans l'économie numérique, dite
        L.C.E.N., nous portons à la connaissance des utilisateurs et visiteurs du site web les informations suivantes.
    </p>
    <h1 class="text-left mt-3" style="color: #f8ad33;margin-bottom: 0.5em !important;">Informations légales :</h1>
    <p>Nom de la Société : SAS CLEM' / Mopeasy <br>
        Adresse : 9 villa des Sablons 92200 Neuilly-sur-Seine <br>
        Tél : +331 86 86 85 85 <br>
        Au Capital de : 27 492 euros<br>
        SIRET : 51945020900019 R.C.S. : 14-01-2010 <br>
        Numéro TVA intracommunautaire : FR49519450209 <br>
        Adresse de courrier électronique : contact@clem.mobi <br>
    </p>


    <p>Site : clem.mobi et clem-e.com</p>
    <p>Le Responsable de la publication est : Bruno Flinois</p>
    <p>Directeur de publication : le président de la société</p>
    <p>Contact : contact@clem.mobi</p> <br>
    <p>Les hébergeurs des sites sont :</p>
    <ul style="margin-bottom: 2.3em;">
        <li style="margin-bottom: 0.7em;">Online SAS - BP 438 - 75366 Paris CEDEX 08 – Tél : 01 84 13 00 00</li>
        <li style="margin-bottom: 0.7em;">OVH SAS - 2 rue Kellermann - 59100 Roubaix – Tél : 1007 et +33 9 72 10 10 07</li>
        <li>Wix-com Inc. - 500 Terry A François Blvd - San Francisco, CA 94158 – Tél : +1 415-639-9034</li>
    </ul>
  


    <h1 class="text-left" style="color: #a2b73d;"><b>2. Description des services fournis :</b></h1>

    <p>Les sites de la société clem, et notamment les sites clem.mobi, fournissent aux utilisateurs enregistrés la
        possibilité des réserver des véhicules en
        autopartage, ainsi que de réserver des bornes de recharge de véhicules électriques et du covoiturage. </p>




    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>3. Propriété intellectuelle et contrefaçons :</b></h1>

    <p>
        La société Clem’ est propriétaire des droits de propriété intellectuelle ou détient les droits d’usage sur tous
        les éléments accessibles sur le site,
        notamment les textes, images, graphismes, logo, icônes, sons, logiciels (mais les chartes graphiques logos etc.
        des partenaires restent bien entendu
        leurs propriétés respectives).
    </p>
    <p>
        Toute reproduction, représentation, modification, publication, adaptation totale ou partielle des éléments du
        site, quel que soit le moyen ou le procédé
        utilisé, est interdite, sauf autorisation écrite préalable obtenue depuis l'email : ludovic.collin@clem-e.com
    </p>
    <p>
        Toute exploitation non autorisée du site ou de l’un quelconque de ces éléments qu’il contient sera considérée
        comme constitutive d’une contrefaçon et
        poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
    </p>



    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>4. Liens hypertextes et cookies :</b></h1>
    <p style="margin-bottom: 1em;">
        Les sites de la société Clem’ contiennent des liens hypertextes vers d’autres sites de la société, ou externes
        (partenaires, informations …) sous la
        responsabilité du propriétaire du site. Cependant, le propriétaire du site n’a pas la possibilité de vérifier à
        tout moment le contenu des sites ainsi visités
        et décline donc toute responsabilité de ce fait quant aux risques éventuels de contenus illicites.
    </p>
    <p>
        L’utilisateur est informé que lors de ses visites sur les sites de Clem' des cookies sont susceptibles de
        s’installer automatiquement sur son ordinateur. Un
        cookie est un fichier de petite taille, qui ne permet pas l’identification de l’utilisateur, mais qui enregistre
        des informations relatives à la navigation d’un
        ordinateur sur un site. Les données ainsi obtenues visent à faciliter la navigation ultérieure sur le site, et
        ont également vocation à permettre diverses
        mesures de fréquentation.
    </p>
    <p>
        Lors de sa première visite sur le site, l'utilisateur se voit afficher cette information relative aux cookies,
        avec la possibilité de les accepter ou non.
    </p>
    <p>
        Le refus d’installation d’un cookie peut entraîner l’impossibilité d’accéder à certains services.
    </p>


    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>5. Protection des biens et des personnes - gestion des données
            personnelles :</b></h1>
    <p class="mb-2">
        Sur les sites de Clem’ le propriétaire du site ne collecte des informations personnelles relatives à
        l'utilisateur que pour le besoin des services proposés :
        coordonnées postales et bancaire, etc., toutes nécessaires à l'utilisation normale des services.
        L'utilisateur
        fournit ces informations en toute
        connaissance de cause, notamment lorsqu'il procède par lui-même à leur saisie. (Il est précisé à
        l'utilisateur
        l’obligation ou non de fournir chacune de
        ces informations).
    </p>
    <p>
        Conformément aux dispositions législatives, tout utilisateur dispose d’un droit d’accès, de rectification,
        de
        suppression et d’opposition aux données
        personnelles le concernant. Pour l’exercer, adressez votre demande par email à protection-donnees@clem-e.com
        par
        email. Selon le cas, pour effectuer
        cette opération sur les données personnelles d'un utilisateur, il sera parfois demandé à l'utilisateur de
        fournir des compléments d'identité pour établir la
        légitimité de la demande.
    </p>
    <p>
        Aucune information personnelle de l'utilisateur des sites de la société Clem’ n'est publiée ou diffusée à
        des tiers sans un accord explicite préalable de
        l'utilisateur. Seule l'hypothèse du rachat des sites de la société Clem’ permettrait la transmission des
        dites informations à l'éventuel acquéreur qui serait
        à son tour tenu de la même obligation de conservation et de modification des données vis à vis de
        l'utilisateur des sites.
    </p>

    <p style="margin-bottom: 4em;">La société Clem' est en conformité avec le RGPD. Pour plus d’information, consultez notre
        <a routerLink="politique-de-confidentialite"> Politique de Confidentialité.</a>
    </p>



</div>